import axios from 'axios';

import routes from 'app/routes';

export default {
  load: (dispatch) => {
    axios
      .get(routes.api.policy_plans.index)
      .then((response) => {
        dispatch({ type: 'LOAD', policyPlans: response.data.data });
      });
  },
};
